import {Button, ButtonProps, useListContext, useNotify,} from "react-admin";
import PublishIcon from "@material-ui/icons/Print";
import {clientNoJson} from "../../dataProvider";
import {url as URL} from "../../constants";
import {getFileNameFromContentDisposition} from "../../shared/utils";
import {useState} from "react";
import {CircularProgress} from "@material-ui/core";

export const PrintDeliveryMarkers8x4BulkButton = (props: ButtonProps) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const { selectedIds, refetch } = useListContext();
  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    let res = null;
    try {
      res = await clientNoJson(`${URL}/deliveries/print_packages_markers_8x4/`, {
        method: "POST",
        data: {
          ids: selectedIds
        },
        responseType: "arraybuffer",
      });
    } catch (err) {
      notify("ra.message.error", "error");
      setLoading(false);
      return;
    }
    const data = res.data; // or res.blob() if using blob responses

    const url = window.URL.createObjectURL(
      new Blob([data], {
        type: res.headers["content-type"],
      })
    );
    const actualFileName = getFileNameFromContentDisposition(
      res.headers["content-disposition"]
    );

    // uses the download attribute on a temporary anchor to trigger the browser
    // download behavior. if you need wider compatibility, you can replace this
    // part with a library such as filesaver.js
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", actualFileName);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) link.parentNode.removeChild(link);
    try {
      refetch();
    }
    catch (e) {

    }

    setLoading(false);

  };

  return (
    <Button
      {...props}
      disabled={loading}
      label="Segnacolli 8x4"
      title="Stampa segnacolli 8 x 4 cm"
      onClick={handleSubmit}
    >
      {loading ? <CircularProgress size={18} thickness={2} /> : <PublishIcon />}
    </Button>
  );
};
